var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoreLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "103.8%",
    height: "112.7%",
    x: "-1.9%",
    y: "-6.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(-16 -11)",
    fill: "#B2B2B2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 22a2 2 0 11.001 3.999A2 2 0 0132 22zm0-5a7 7 0 017 7c0 .84-.248 1.944-.743 3.313l-.198.526-.22.55-.244.576-.131.297-.279.612-.302.637-.325.662-.348.687-.372.712-.395.737-.206.377-.43.774-.453.798-.476.824-.5.848-.522.873a1 1 0 01-1.646.096l-.066-.096-.529-.883-.51-.867-.486-.84-.461-.816-.438-.789-.413-.763-.197-.371-.377-.725-.352-.698-.328-.672-.304-.646c-.097-.211-.19-.418-.28-.62l-.254-.595-.231-.569C25.328 26.283 25 24.966 25 24a7 7 0 017-7zm0 2a5 5 0 00-5 5c0 .51.14 1.196.418 2.053l.15.442c.055.152.113.309.175.47l.197.498.22.526.244.553.267.58.29.607.313.633.336.66.36.686.382.713.406.737.429.764.452.789.361.619.358-.615.465-.81.44-.783.415-.756.39-.73.367-.7.342-.675.317-.646.293-.617.27-.59.243-.56.22-.532.195-.503.171-.474c.318-.917.488-1.657.511-2.21L37 24a5 5 0 00-5-5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreLocation);
export default __webpack_public_path__ + "static/media/core-location.8d4d4506.svg";
export { ForwardRef as ReactComponent };